/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logo[_ngcontent-%COMP%]{display:inline-block;background-image:url(/assets/images/smartvote-australia-logo.png);background-size:contain;background-repeat:no-repeat}.logo.small[_ngcontent-%COMP%]{width:130px;height:40px}.logo.big[_ngcontent-%COMP%]{width:221px;height:68px}.logo.big.no-text[_ngcontent-%COMP%]{height:50px;width:50px;background-size:auto 64px;background-position:right top}.logo.small.no-text[_ngcontent-%COMP%]{height:32px;width:32px;background-size:auto 42px;background-position:right top}"];
export { styles as styles };
